/* AMANA — Cadeaux automatiques (dustbag + magazine), module unifié.
 * Remplace deux logiques concurrentes : le bloc inline `dbSync` (dustbag) du theme.liquid
 * et l'ancien `auto-gift.js` (magazine 500 € sur sous-total). Un seul poll, un seul garde.
 *
 * Règles (validées 2026-06-07) :
 *   • Dustbag (49410836627796)  : ajouté si AU MOINS un article payant a final_line_price >= 50,00 €.
 *   • Magazine (55675544142164) : ajouté si le SOUS-TOTAL hors cadeaux >= 500,00 €,
 *     calculé AVANT code réduction (original_line_price = prix de ligne avant remise).
 *   • Exclusion B2B : aucun cadeau pour les clients tagués b2b / wholesale / reseller.
 * Les deux cadeaux sont indépendants (un sac à 350 € déclenche les deux). Les produits
 * d'entretien (tous < 50 €) et les cadeaux (0 €) sont exclus de facto par les seuils.
 *
 * Refresh du drawer "rip Qikify" via window.QscCart.refresh() (le drawer n'écoute aucun
 * event custom — c'est sa seule API de rafraîchissement). Prix en centimes (entiers /cart.js).
 */
(function () {
  'use strict';

  var DUSTBAG_VID  = 49410836627796;
  var DUSTBAG_MIN  = 5000;    // 50,00 € — seuil PAR ARTICLE (final_line_price d'une ligne)
  var MAGAZINE_VID = 55675544142164;
  var MAGAZINE_MIN = 50000;   // 500,00 € — seuil sur le SOUS-TOTAL hors cadeaux, AVANT code réduction
  var GIFT_VIDS    = [DUSTBAG_VID, MAGAZINE_VID];
  var B2B_TAGS     = ['b2b', 'wholesale', 'reseller'];

  var POLL_MS       = 3000;   // filet de sécurité (mutations hors fetch)
  var DEBOUNCE_MS   = 400;    // après une mutation panier interceptée
  var INIT_DELAY_MS = 1200;   // panier pré-rempli au chargement

  var processing = false;
  var lastSig = '';           // signature du dernier état STABLE traité (anti-travail inutile)

  function isB2B() {
    var tags = window.__amanaCustomerTags || [];
    for (var i = 0; i < B2B_TAGS.length; i++) {
      if (tags.indexOf(B2B_TAGS[i]) !== -1) return true;
    }
    return false;
  }

  function getCart() {
    return fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function refreshDrawer() {
    if (window.QscCart && typeof window.QscCart.refresh === 'function') {
      window.QscCart.refresh();
    }
    // Page /cart : la liste est rendue par cart-form (rebuild via component-cart.js, chargé sur
    // template cart) — sans ça, les cadeaux ajoutés/retirés ici restent invisibles jusqu'au reload.
    // Vécu : arrivée par lien de panier partagé (cadeaux exclus du permalink, re-ajoutés ici,
    // mais absents de la page /cart d'atterrissage).
    if (document.getElementById('section-cart') && typeof window.refreshCart === 'function') {
      window.refreshCart();
    }
  }

  function sync() {
    if (processing) return;
    processing = true;

    getCart().then(function (cart) {
      var sig = cart.items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(',');
      if (sig === lastSig) { processing = false; return; }   // état inchangé depuis le dernier passage stable

      var b2b = isB2B();

      // État courant des cadeaux + métriques calculées HORS cadeaux.
      // ⚠️ Un même variant cadeau peut produire PLUSIEURS lignes (Shopify sépare par properties) :
      // ex. dustbag de l'ancien thème (sans _auto_gift) + dustbag du nouveau auto-gift (avec marqueur)
      // pendant la transition de publication → vu en prod (commande A4968, 2026-06-12). On collecte
      // TOUTES les lignes de chaque cadeau, pas juste la dernière, pour pouvoir dédupliquer.
      var dustbagLines = [], magazineLines = [];
      var hasQualifyingItem = false;   // au moins un article >= 50 €
      var subtotalExclGifts = 0;       // somme des lignes hors cadeaux

      // Sac en quantité > 1 → ramener à 1 (pièces uniques ; course add.js en rafale — qty 2
      // acceptée sur stock 1, cf wiki — ou mutation hors drawer : 2e onglet, app Shop).
      // Heuristique sac = prix UNITAIRE >= 50 € (même seuil validé que le dustbag).
      var capKeys = [];

      cart.items.forEach(function (it) {
        if (it.variant_id === DUSTBAG_VID)  { dustbagLines.push(it);  return; }
        if (it.variant_id === MAGAZINE_VID) { magazineLines.push(it); return; }
        // Magazine : seuil "avant code réduction" → original_line_price (prix de ligne avant toute remise).
        subtotalExclGifts += it.original_line_price;
        // Dustbag : seuil par article inchangé (final_line_price = prix effectif de la ligne).
        if (it.final_line_price >= DUSTBAG_MIN) hasQualifyingItem = true;
        if (it.final_price >= DUSTBAG_MIN && it.quantity > 1) capKeys.push(it.key);
      });

      var wantDustbag  = !b2b && hasQualifyingItem;
      var wantMagazine = !b2b && (subtotalExclGifts >= MAGAZINE_MIN);

      var addItems = [];
      if (wantDustbag  && dustbagLines.length  === 0) addItems.push({ id: DUSTBAG_VID,  quantity: 1, properties: { _auto_gift: 'dustbag' } });
      if (wantMagazine && magazineLines.length === 0) addItems.push({ id: MAGAZINE_VID, quantity: 1, properties: { _auto_gift: 'magazine' } });

      var removeKeys = [];
      var fixKeys = capKeys;

      // Réconcilie un cadeau à EXACTEMENT une ligne qty 1 (si voulu) ou zéro (sinon).
      // Couvre les 3 cas de doublon : lignes multiples du même variant (properties différentes),
      // quantité > 1 sur une ligne, et cadeau présent mais non voulu. Auto-réparant au prochain sync.
      function reconcileGift(lines, want) {
        if (!want) { lines.forEach(function (l) { removeKeys.push(l.key); }); return; }
        if (lines.length === 0) return;                                    // ajouté via addItems
        lines.slice(1).forEach(function (l) { removeKeys.push(l.key); });  // surnuméraires → 0
        if (lines[0].quantity > 1) fixKeys.push(lines[0].key);            // la ligne gardée → qty 1
      }
      reconcileGift(dustbagLines, wantDustbag);
      reconcileGift(magazineLines, wantMagazine);

      if (addItems.length === 0 && removeKeys.length === 0 && fixKeys.length === 0) {
        lastSig = sig;            // rien à faire : état stable mémorisé
        processing = false;
        return;
      }

      // Ajouts en une requête atomique, puis retraits séquentiels, puis refresh du drawer.
      var chain = Promise.resolve();
      if (addItems.length) {
        chain = chain.then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items: addItems })
          });
        });
      }
      removeKeys.forEach(function (key) {
        chain = chain.then(function () {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ id: key, quantity: 0 })
          });
        });
      });
      fixKeys.forEach(function (key) {
        chain = chain.then(function () {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ id: key, quantity: 1 })
          });
        });
      });

      chain.then(function () {
        lastSig = '';            // le panier a changé : forcer un recompute au prochain passage
        processing = false;
        refreshDrawer();
      }).catch(function () {
        lastSig = '';
        processing = false;
      });
    }).catch(function () { processing = false; });
  }

  // --- Déclencheur 1 : après chaque mutation panier, via hook fetch (réactif). ---
  var origFetch = window.fetch;
  var debounceTimer = null;
  function scheduleSync() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(sync, DEBOUNCE_MS);
  }
  window.fetch = function () {
    var first = arguments[0];
    var url = (typeof first === 'string') ? first : (first && first.url) || '';
    var isMutation = /\/cart\/(add|change|update|clear)(\.js)?/.test(url);
    var p = origFetch.apply(this, arguments);
    if (isMutation) {
      p.then(function (res) { if (res && res.ok) scheduleSync(); }, function () {});
    }
    return p;   // promesse originale intacte pour l'appelant
  };

  // --- Déclencheur 2 : filet de sécurité (mutations qui ne passeraient pas par fetch). ---
  setInterval(sync, POLL_MS);

  // --- Déclencheur 3 : au chargement (panier déjà rempli). ---
  if (document.readyState === 'complete') {
    setTimeout(sync, INIT_DELAY_MS);
  } else {
    window.addEventListener('load', function () { setTimeout(sync, INIT_DELAY_MS); });
  }
})();
